import { apiAthenas } from '@/services/api/apiAthenas'
import { History } from '@/types/History'

export async function getBoardHistory(id: string) {
  const { data } = await apiAthenas.get<History[]>(`boards/${id}/history`)

  return data
}
